<template>
  <div class="max-w-600 min-w-60 min-h-48 md:ml-12 md:mr-6 p-4 md:pr-8 rounded-md">
    <div class="flex mb-4">
      <img class="inline-block h-5 mr-4" src="./assets/double-quotes-l.svg" alt="" />
      <div>
        <span class="text-xl font-medium leading-10">{{ content.text }}</span>
        <img
          class="inline-block h-5 ml-4"
          src="./assets/double-quotes-r.svg"
          alt=""
        />
      </div>
    </div>

    <div v-if="content.from" class="text-right w-full truncate text-gray-600 text-base">—— {{ content.from }}</div>
  </div>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Quotation extends Vue {
  @Prop({ type: Object }) content!: Content;
}
</script>

<style scoped>
.double-quotes {
  position: relative;
}
.double-quotes::before,
.double-quotes::after {
  position: absolute;
  top: 0;
  left: -38px;
  display: inline-block;
  width: 35px;
  height: 35px;
  background-image: url('./assets/double-quotes-l.svg');
  background-size: cover;
  content: '';
}
.double-quotes::after {
  top: initial;
  right: -38px;
  bottom: 0;
  left: initial;
  background-image: url('./assets/double-quotes-r.svg');
}
</style>
